import { createStore } from "devextreme-aspnet-data-nojquery";
import { errorToString } from "../api";
import { APIVersion } from "../api/src/requests/request";

export function generateDS(apiURL: string, path: string, key: string = 'id', isFullPath: boolean = false) {
    const fullPath = isFullPath ? `${apiURL}/${path}` : `${apiURL}/${APIVersion.v1_0}/admin/${path}`
    return {
        store: createStore({
            key: key,
            loadUrl: fullPath,
            insertUrl: fullPath,
            updateUrl: fullPath,
            deleteUrl: fullPath,
            onBeforeSend: (method, e) => {
                if (['delete', 'update'].indexOf(method) > -1) {
                    e.url += '/' + e.data.key
                    delete e.data.key
                    e.data = (e.data.values)
                    e.dataType = 'application/json'
                    e.contentType = 'application/json'
                } else if (method == 'insert') {
                    e.data = (e.data.values)
                    e.dataType = 'application/json'
                    e.contentType = 'application/json'
                }

                e.xhrFields = {
                    withCredentials: true
                }
            },
            onAjaxError: (error) => {
                if (error.xhr.response) {
                    let err = JSON.parse(error.xhr.response)
                    error.error = new Error(errorToString(err).join('\n'))
                }
                return error
            }
        })
    };
}

export const ActiveColumnOptions = {
    dataType: 'string',
    dataField: 'active',
    lookup: {
        dataSource: ['Active', 'Inactive']
    },
    allowFiltering: true,
    allowSearch: false
}


// WEBPACK FOOTER //
// ./src/utils/datasource.ts